import { render, staticRenderFns } from "./HostHosGtest2.vue?vue&type=template&id=452005c2&scoped=true&"
import script from "./HostHosGtest2.vue?vue&type=script&lang=js&"
export * from "./HostHosGtest2.vue?vue&type=script&lang=js&"
import style0 from "./HostHosGtest2.vue?vue&type=style&index=0&id=452005c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452005c2",
  null
  
)

export default component.exports